import React from 'react';
import DefaultView from '../../components/shared/template/DefaultView';
import { UserContext } from '../../context/UserContext';
import { CompanyContext } from '../../context/CompanyContext';
import { ViewAccess, getViewAccess } from '../../util/user_access';
import AccessDenied from '../shared/AccessDenied';
import LoadingScreen from '../../components/shared/loading/LoadingScreen';
import { GroupContext } from '../../context/GroupContext';

const AssessmentDashboard = () => {
  const { user } = React.useContext(UserContext);
  const { group } = React.useContext(GroupContext);
  const { company } = React.useContext(CompanyContext);
  const [access, setAccess] = React.useState<ViewAccess>(null);

  React.useEffect(() => {
    setAccess(
      group && company && user
        ? getViewAccess(user, group.id, company.id, 'sustainability.assessment')
        : null
    );
  }, [user, company]);

  return !user || access === null ? (
    <LoadingScreen />
  ) : access !== 'none' ? (
    <DefaultView title="Dashboard" />
  ) : (
    <AccessDenied />
  );
};

export default AssessmentDashboard;
